"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawWalletChainToJSON = exports.WithdrawWalletChainFromJSONTyped = exports.WithdrawWalletChainFromJSON = exports.WithdrawWalletChain = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var WithdrawWalletChain;
(function (WithdrawWalletChain) {
    WithdrawWalletChain["BASE"] = "BASE";
    WithdrawWalletChain["SOLANA"] = "SOLANA";
})(WithdrawWalletChain = exports.WithdrawWalletChain || (exports.WithdrawWalletChain = {}));
function WithdrawWalletChainFromJSON(json) {
    return WithdrawWalletChainFromJSONTyped(json, false);
}
exports.WithdrawWalletChainFromJSON = WithdrawWalletChainFromJSON;
function WithdrawWalletChainFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.WithdrawWalletChainFromJSONTyped = WithdrawWalletChainFromJSONTyped;
function WithdrawWalletChainToJSON(value) {
    return value;
}
exports.WithdrawWalletChainToJSON = WithdrawWalletChainToJSON;
